import { render } from "./depict-collection.vue?vue&type=template&id=8fb7b9b2"
import script from "./depict-collection.vue?vue&type=script&lang=js"
export * from "./depict-collection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__